var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoppingTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4151 4.17147C11.1652 3.42139 12.1825 3 13.2433 3H18.0003C19.657 3 21 4.34303 21 5.99974V10.7567C21 11.8175 20.5786 12.8348 19.8285 13.5849L13.292 20.1214C12.1205 21.2929 10.2212 21.2929 9.04972 20.1214L3.8786 14.9503C2.70713 13.7788 2.70713 11.8795 3.8786 10.708L10.4151 4.17147ZM13.2433 4.99983C12.7129 4.99983 12.2043 5.21052 11.8292 5.58556L5.29269 12.1221C4.9022 12.5126 4.9022 13.1457 5.29269 13.5362L10.4638 18.7073C10.8543 19.0978 11.4874 19.0978 11.8779 18.7073L18.4144 12.1708C18.7895 11.7957 19.0002 11.2871 19.0002 10.7567V5.99974C19.0002 5.4475 18.5525 4.99983 18.0003 4.99983H13.2433Z",
    fill: "#6B92FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 10.4366L6.43662 9L16 18.5634L14.5634 20L5 10.4366Z",
    fill: "#6B92FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 8C17 8.55228 16.5523 9 16 9C15.4477 9 15 8.55228 15 8C15 7.44772 15.4477 7 16 7C16.5523 7 17 7.44772 17 8Z",
    fill: "#6B92FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingTag);
export default __webpack_public_path__ + "static/media/shopping-tag.4f47a84c.svg";
export { ForwardRef as ReactComponent };